import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GeneralStateContext, MENU_STATE_NAMES } from './app.general.state';

// Ruta "hogar" de cada estado: adonde se redirige cuando la navegación
// pedida no corresponde al estado actual de la app.
const STATE_HOME: Record<string, string> = {
  ConfigState: '/config',
  LoginState: '/login',
  MenuState: '/dashboard',
  AdminMenuState: '/dashboard',
  MarketerMenuState: '/dashboard',
};

/**
 * Guard global del state machine (ConfigState → LoginState → MenuState*).
 *
 * Reglas:
 * - ConfigState: solo /config es accesible.
 * - LoginState:  solo /login es accesible.
 * - MenuState* (MenuState, AdminMenuState, MarketerMenuState):
 *   cualquier página excepto /config y /login.
 *
 * Antes de decidir se ejecuta validate() hasta que el estado se estabilice:
 * cada validate() avanza como máximo una transición, y tras un arranque en
 * frío pueden necesitarse varias hasta alcanzar un estado terminal.
 */
export const generalStateGuard: CanActivateFn = async (_route, routerState) => {
  const context = inject(GeneralStateContext);
  const router = inject(Router);

  await context.initializeState();

  let stateName = await context.getStateName();
  let previous: string;
  do {
    previous = stateName;
    await context.validate();
    stateName = await context.getStateName();
  } while (stateName !== previous);

  const target = '/' + routerState.url.split('?')[0].split('/')[1];

  const isMenu = MENU_STATE_NAMES.has(stateName);
  const allowed = isMenu
    ? target !== '/config' && target !== '/login'
    : target === STATE_HOME[stateName];

  return allowed ? true : router.parseUrl(STATE_HOME[stateName]);
};
